/* eslint-disable no-unused-vars */
import axios from "@/axios.js";

const urlTeacher = "user/teachers";

export default {
  addTeacher({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios
        .post(urlTeacher, user)
        .then((response) => {
          commit("ADD_TEACHER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchTeachers({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(urlTeacher, { params: param })
        .then((response) => {
          const data = response.data.data;
          if (data && data.pagination)
            commit("SET_TEACHERS_WITH_PAGINATION", response.data.data);
          else commit("SET_TEACHERS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchTeacher({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${urlTeacher}/${params.id}`, { params: params })
        .then((response) => {
          commit("SET_TEACHER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateTeacher({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${urlTeacher}/${item.id}`, item.formData, {
          headers: { "content-type": "multipart/form-data" },
        })
        .then((response) => {
          commit("UPDATE_TEACHER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setPagination({ commit }, page) {
    commit("SET_PAGINATION", page);
  },

  async deleteMultiple({ commit }, payload) {
    return await axios.post("/user/teachers/delete-multiple", payload);
  },

  async import({ commit }, payload) {
    return await axios.post("/user/teacher/import", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  async resetTeachers({ commit }, payload) {
    commit("SET_TEACHERS", payload || []);
  },

  async validateEmail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/user/teacher/validate-email', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response.data.message || error.response.data.error.message);
        });
    });
  },

  async validatePhone({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post('/user/teacher/validate-phone', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response.data.message || error.response.data.error.message);
        });
    });
  },
};
